import React, { useEffect, useState } from "react";
import { Modal, Descriptions, Typography, Tag, Spin, Badge, Divider } from "antd";
import dayjs from "dayjs";
import ReportPoolDataService from "src/services/ReportPoolDataService";
import TableCustom from "src/components/Table/CustomTable"

const { Title } = Typography
const orderStatusMap = {
  0: { text: "Chờ duyệt", status: "processing" },
  1: { text: "Đã duyệt", status: "success" },
  2: { text: "Từ chối", status: "error" },
};

const packageStatusMap = {
  0: { text: "Chưa kích hoạt", status: "warning" },
  1: { text: "Đã kích hoạt", status: "success" },
  2: { text: "Lỗi / Hủy", status: "error" },
};

const DetailReportPurchase = ({ open, onCancel, id }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (open && id) {
      fetchDetail();
    }
  }, [open, id]);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const res = await ReportPoolDataService.getDetailReportPackageOrderM2M(id);
      setDetail(res.success);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "ID",
      width: 60,
    },
    {
      title: "Mã gói",
      dataIndex: "package_code",
    },
    {
      title: "Loại gói",
      dataIndex: "package_type",
    },
    {
      title: "Thuê bao chủ",
      dataIndex: "parent_phone",
      render: (val) => val || "---",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => (
        <Badge
          status={orderStatusMap[status]?.status}
          text={orderStatusMap[status]?.text}
        />
      ),
    },
  ];

  const columnsMonth = [
    {
      title: "Tháng",
      dataIndex: "apply_month",
      key: "apply_month",
      align: "center",
    },
    {
      title: "Dung lượng (GB)",
      dataIndex: "total_data_volume_gb",
      key: "total_data_volume_gb",
      align: "center",
      render: (val) => <b style={{ color: val > 0 ? "#f5222d" : "inherit" }}>{val} GB</b>,
    },
  ];

  return (
    <Modal
      title="Chi tiết báo cáo gói data đã sử dụng"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={850}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        detail && (
          <>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Mã đơn hàng" span={2}>
                {detail.order_code}
              </Descriptions.Item>

              <Descriptions.Item label="Mã gói">
                {detail.package_code}
              </Descriptions.Item>

              <Descriptions.Item label="Loại gói">
                {detail.package_type}
              </Descriptions.Item>

              <Descriptions.Item label="Giá bán">
                {Number(detail.sale_price).toLocaleString()} đ
              </Descriptions.Item>

              <Descriptions.Item label="Loại giảm giá">
                {detail.discount_type === "fixed" ? "Cố định" : "Phần trăm"}
              </Descriptions.Item>

              <Descriptions.Item label="Giá trị giảm">
                {Number(detail.discount_value).toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="Tiền sau chiết khẩu">
                {Number(detail.price_discount).toLocaleString()}
              </Descriptions.Item>

              <Descriptions.Item label="Số gói trong đơn">
                {detail.package_excels_count}
              </Descriptions.Item>

              <Descriptions.Item label="Trạng thái đơn">
                <Badge
                  status={orderStatusMap[detail.status]?.status}
                  text={orderStatusMap[detail.status]?.text}
                />
              </Descriptions.Item>

              <Descriptions.Item label="Khách hàng">
                {detail.customer?.fullname}
              </Descriptions.Item>

              <Descriptions.Item label="Ghi chú" span={2}>
                {detail.note}
              </Descriptions.Item>

              <Descriptions.Item label="Ngày tạo">
                {dayjs(detail.created_at).format("DD/MM/YYYY HH:mm")}
              </Descriptions.Item>

              <Descriptions.Item label="Cập nhật">
                {dayjs(detail.updated_at).format("DD/MM/YYYY HH:mm")}
              </Descriptions.Item>
            </Descriptions>

            <div style={{ marginTop: 24 }}>
              <Title level={5}>Lịch sử sử dụng dung lượng theo tháng</Title>
              <TableCustom
                isPrimary
                columns={columnsMonth}
                dataSource={detail.used_data_by_month || []}
                rowKey="apply_month"
                textEmpty="Không có dữ liệu sử dụng"
                pagination={{
                  current: 1,
                  pageSize: 12,
                  hideOnSinglePage: true
                }}
                size="small"
              />
            </div>

            <Divider />
          </>
        )

      )}
    </Modal>
  );
};

export default DetailReportPurchase;
